import {
    Box,
    Button,
    Card,
    CardActions,
    CardContent,
    Typography,
} from '@mui/material';
import moment from 'moment';
import { handleStatus } from '../../../../shared/utils';
import { IResponseDepositAcceptance } from '../../../../shared/services/types/response';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';

interface CardDepositAcceptanceProps {
    depositValue: IResponseDepositAcceptance;
    onAccept: (id: string) => void;
    onRefuse: (id: string) => void;
    isLoading?: boolean;
}

const CardDepositAcceptance = ({
    depositValue,
    onAccept,
    onRefuse,
    isLoading = false,
}: CardDepositAcceptanceProps) => {
    return (
        <Card>
            <CardContent>
                <Typography variant="h6" gutterBottom color="secondary.main">
                    {depositValue?.number_control_ccs}
                </Typography>
                <Typography variant="body2">
                    Número da Conta: {depositValue?.account_deposit_number}
                </Typography>
                <Typography variant="body2">
                    Data de Criação:{' '}
                    {moment(depositValue?.created_at).format('DD/MM/yyyy HH:mm')}
                </Typography>
                {depositValue?.account_groups && depositValue.account_groups.length > 0 && (
                    <Typography variant="body2">
                        Grupos de Conta: {depositValue.account_groups.length}
                    </Typography>
                )}
                <Typography mt={1} textAlign={'end'} variant="body2">
                    <Box
                        component="span"
                        sx={{
                            display: 'inline-block',
                            px: 1.5,
                            py: 0.2,
                            borderRadius: 10,
                            fontSize: 12,
                            bgcolor: '#FFC107',
                            color: 'white',
                        }}
                    >
                        {handleStatus(depositValue?.status)}
                    </Box>
                </Typography>
            </CardContent>
            <CardActions
                sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    flexDirection: 'row',
                    gap: 1,
                }}
            >
                <Button
                    size="small"
                    color="success"
                    variant="contained"
                    startIcon={<CheckCircleIcon />}
                    onClick={() => onAccept(depositValue?.id)}
                    disabled={isLoading}
                >
                    Aceitar
                </Button>
                <Button
                    size="small"
                    color="error"
                    variant="outlined"
                    startIcon={<CancelIcon />}
                    onClick={() => onRefuse(depositValue?.id)}
                    disabled={isLoading}
                >
                    Recusar
                </Button>
            </CardActions>
        </Card>
    );
};

export default CardDepositAcceptance;
